import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { SUGGEST_ITEM_FLEX_GAP_SIZE } from '../constants';
export function useIconMargin(suggestions) {
  // В этот список попадают только элементы иконок из итемов с { type: 'title' }.
  // Только они нужны для расчета отступа.
  var titleItemsIconElements = React.useRef([]);
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    iconMargin = _React$useState2[0],
    setIconMargin = _React$useState2[1];
  React.useEffect(function () {
    titleItemsIconElements.current = _toConsumableArray(Array(suggestions.length)).map(function (_el, i) {
      return titleItemsIconElements.current[i];
    });
    setIconMargin(Math.max.apply(Math, [0].concat(_toConsumableArray(titleItemsIconElements.current.map(function (el) {
      var _el$clientWidth;
      return (_el$clientWidth = el === null || el === void 0 ? void 0 : el.clientWidth) !== null && _el$clientWidth !== void 0 ? _el$clientWidth : 0;
    })))));
  }, [suggestions]);
  var setTitleItemRefByIndex = React.useCallback(function (listIndex) {
    return function (iconElement) {
      if (suggestions[listIndex].type === 'title') {
        titleItemsIconElements.current[listIndex] = iconElement;
      }
    };
  }, [suggestions]);
  var getIconMarginForItem = React.useCallback(function (suggestion) {
    if (suggestion.leftIcon || !iconMargin) {
      return 0;
    }
    return iconMargin + SUGGEST_ITEM_FLEX_GAP_SIZE;
  }, [iconMargin]);
  return {
    getIconMarginForItem: getIconMarginForItem,
    setTitleItemRefByIndex: setTitleItemRefByIndex
  };
}